import type { LucideIcon } from 'lucide-react';
import {
  AlertTriangle,
  BadgeCheck,
  Ban,
  BarChart3,
  Bot,
  CalendarDays,
  CheckSquare,
  Circle,
  ClipboardList,
  Clock,
  FileText,
  FolderOpen,
  GraduationCap,
  Inbox,
  LayoutDashboard,
  MessageSquare,
  Settings,
  Store,
  Thermometer,
  Timer,
  Umbrella,
  UserRound,
  Users,
} from 'lucide-react';

const ICONS_BY_HREF: Record<string, LucideIcon> = {
  '/': LayoutDashboard,
  '/inbox': Inbox,
  '/employees': Users,
  '/scheduling': CalendarDays,
  '/attendance': Clock,
  '/timecards': ClipboardList,
  '/settings?section=time-stations': Timer,
  '/settings': Settings,
  '/shift-marketplace': Store,
  '/reports': BarChart3,
  '/my-attendances': Clock,
  '/my-schedules': CalendarDays,
  '/my-tasks': CheckSquare,
  '/messages': MessageSquare,
  '/my-messages': MessageSquare,
  '/my-trainings': GraduationCap,
  '/my-licenses': BadgeCheck,
  '/my-documents': FileText,
  '/my-holidays': Umbrella,
  '/my-unavailability': Ban,
  '/my-team': UserRound,
  '/my-sick-leave': Thermometer,
  '/my-incidents': AlertTriangle,
  '/ai-assistant': Bot,
};

export const myRecordsIcon = FolderOpen;

export function sidebarIcon(href: string): LucideIcon {
  if (ICONS_BY_HREF[href]) return ICONS_BY_HREF[href];
  const path = href.split('?')[0];
  return ICONS_BY_HREF[path] ?? Circle;
}
